import React, { useState } from "react";
import { apiRequest } from "../api";
import countries from "../data/countries.json";

const AddTourTemplateModal = ({ tourTemplate, onClose, onSave }) => {
    const isEdit = !!tourTemplate;
    const [name, setName] = useState(tourTemplate?.name || "");
    const [dateFrom, setDateFrom] = useState(tourTemplate?.date_from || "");
    const [dateTo, setDateTo] = useState(tourTemplate?.date_to || "");
    const [country, setCountry] = useState(tourTemplate?.country || "");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            if (isEdit) {
                await apiRequest(
                    `${apiUrl}/tour-templates/${tourTemplate.id}`,
                    "PUT",
                    { name, date_from: dateFrom, date_to: dateTo, country },
                    token
                );
            } else {
                await apiRequest(
                    `${apiUrl}/tour-templates`,
                    "POST",
                    { name, date_from: dateFrom, date_to: dateTo, country },
                    token
                );
            }
            onSave();
        } catch (err) {
            setError("Failed to save template.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "500px",
                    maxHeight: "90vh",
                    overflowY: "auto",
                }}
            >
                <h4>{isEdit ? "Edit Tour Template" : "Add Tour Template"}</h4>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Name:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            disabled={loading}
                        />
                    </div>
                    <div className="form-group">
                        <label>Date From:</label>
                        <input
                            type="date"
                            className="form-control"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <div className="form-group">
                        <label>Date To:</label>
                        <input
                            type="date"
                            className="form-control"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    <div className="form-group">
                        <label>Country (Optional):</label>
                        <select
                            className="form-control"
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            disabled={loading}
                        >
                            <option value="" disabled>
                                -- Select a Country --
                            </option>
                            {countries.map((c) => (
                                <option key={c.name} value={c.name}>
                                    {c.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? "Saving..." : "Save"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
                {error && (
                    <p
                        style={{
                            marginTop: "10px",
                            color: "red",
                        }}
                    >
                        {error}
                    </p>
                )}
            </div>
        </div>
    );
};

export default AddTourTemplateModal; 